/**
 * Auth helpers over the Supabase session, shared by both apps.
 */
import { supabase, SUPABASE_CONFIGURED } from './supabase'

/**
 * Get the current access token from the Supabase session, or null.
 */
export async function getAccessToken(): Promise<string | null> {
  if (!SUPABASE_CONFIGURED) return null
  try {
    const { data: { session } } = await supabase.auth.getSession()
    return session?.access_token ?? null
  } catch {
    return null
  }
}
